import './PageShell.css';
import { ThemeProvider } from '@mui/material';
import { theme } from 'web/config/theme';
import { ReactNode, StrictMode } from 'react';
import type {} from '@mui/x-data-grid/themeAugmentation';
import type { PageContext } from './types';
import { PageContextProvider } from './usePageContext';
import '@fontsource/lato/400.css';
import '@fontsource/lato/400-italic.css';
import '@fontsource/lato/700.css';
import '@fontsource/lato/900.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';

/**
 * PageShell Props.
 */
type PageShellProps = {
  /**
   * Components.
   */
  children: ReactNode;
  /**
   * Page context.
   */
  pageContext: PageContext;
};

/**
 *
 * Page content.
 *
 * @param props Content props.
 * @param props.children Components.
 * @returns Content.
 */
const Content = ({
  children,
}: {
  /**
   * Components.
   */
  children: ReactNode;
}): JSX.Element => {
  return <>{children}</>;
};

/**
 * Page shell.
 *
 * @param props PageShellProps.
 * @param props.children Components.
 * @param props.pageContext Page context.
 * @returns Page.
 */
export const PageShell = ({ children, pageContext }: PageShellProps): JSX.Element => {
  return (
    <StrictMode>
      <PageContextProvider pageContext={pageContext}>
        <ThemeProvider theme={theme}>
          <Content>{children}</Content>
        </ThemeProvider>
      </PageContextProvider>
    </StrictMode>
  );
};
